import * as React from 'react'
import { X } from '@phosphor-icons/react'
import { useDrawerContext } from 'src/design-system'

interface HeaderProps {
  title: string
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  const { closeDrawer } = useDrawerContext()

  return (
    <div
      className="py-4 mt-0.5 px-4 flex flex-row items-center"
      style={{ borderBottom: '1px solid rgb(228, 233, 243)' }}
    >
      <h3 className="mr-auto text-sm font-bold whitespace-nowrap">{title}</h3>
      <button onClick={closeDrawer} title="Close drawer">
        <X weight="bold" className="w-4 h-4 text-gray-900" />
      </button>
    </div>
  )
}
